module.exports = vendor_2eea9c464ebf2b2afd65;